import Facturas from './Facturas';

export default Facturas;
